import MindsetsJsSDK from "mindsets-js-sdk";
import {LoadingAction} from "mindsets-js-sdk/src/react/layout/actions";

export const LOADED_VOTES = '[votes] Votes loaded';
export const LOADED_VOTES_PAGES = '[votes] Loaded pages';
export const LOADED_VOTES_TOTAL = '[votes] Loaded total';
export const LOADED_VOTES_CURRENT = '[votes] Loaded current';
export const LOADED_VOTES_LIMIT = '[votes] Loaded limit';

export const LoadVotesAction = options => dispatch => {
    dispatch(LoadingAction(true, 'Loading Votes'));

    return MindsetsJsSDK().API.get('votes', options)
        .then(response => {
            dispatch(LoadedVotesAction(response.items));
            dispatch(LoadedVotesPagesAction(response.pages));
            dispatch(LoadedVotesTotalAction(response.total));
            dispatch(LoadedVotesCurrentAction(response.pages >= response.current ? response.current : 1));
            dispatch(LoadedVotesLimitAction(response.limit));
            dispatch(LoadingAction(false));

            return response.items;
        });
}
export const LoadedVotesAction = payload => ({
    type: LOADED_VOTES,
    payload
});
export const LoadedVotesPagesAction = payload => ({
    type: LOADED_VOTES_PAGES,
    payload
});
export const LoadedVotesTotalAction = payload => ({
    type: LOADED_VOTES_TOTAL,
    payload
});
export const LoadedVotesCurrentAction = payload => ({
    type: LOADED_VOTES_CURRENT,
    payload
});
export const LoadedVotesLimitAction = payload => ({
    type: LOADED_VOTES_LIMIT,
    payload
});
